<div class="p-dialog-content-wrapper" [innerHTML]="safeDescription"></div>

<div class="p-dialog-footer">
	<p-button label="OK" (onClick)="onClose()"></p-button>
</div>
